module.exports = __webpack_public_path__ + "static/media/Windy City Live _ 4-30-2015.820f893a.jpg";